// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsCustomEventPropertySchemaResult = arrayOf(
  objectOf(
    {
      displayName: string,
      path: string,
      type: string,
    },
    { strict: false }
  )
);
